module.exports = __webpack_public_path__ + "img/44_BF22_biodiversity.bdf6d262.jpg";